'use strict';

const permissions = require('./permissions');

module.exports = {
  [permissions.ADMIN_ACTIVITIES]: true,
  [permissions.ADMIN_ACTIVITIES_CREATE]: true,
  [permissions.ADMIN_ACTIVITIES_READ]: true,
  [permissions.ADMIN_ACTIVITIES_UPDATE]: true,
  [permissions.ADMIN_ACTIVITIES_DELETE]: true,

  [permissions.ADMIN_SEGMENTS]: true,
  [permissions.ADMIN_SEGMENTS_CREATE]: true,
  [permissions.ADMIN_SEGMENTS_READ]: true,
  [permissions.ADMIN_SEGMENTS_UPDATE]: true,
  [permissions.ADMIN_SEGMENTS_DELETE]: true,

  [permissions.ADMIN_USER_CLIENTS]: true,
  [permissions.ADMIN_USER_CLIENTS_CREATE]: true,
  [permissions.ADMIN_USER_CLIENTS_READ]: true,
  [permissions.ADMIN_USER_CLIENTS_UPDATE]: true,
  [permissions.ADMIN_USER_CLIENTS_DELETE]: true,

  [permissions.ADMIN_USER_GROUPS]: true,
  [permissions.ADMIN_USER_GROUPS_CREATE]: true,
  [permissions.ADMIN_USER_GROUPS_READ]: true,
  [permissions.ADMIN_USER_GROUPS_UPDATE]: true,
  [permissions.ADMIN_USER_GROUPS_DELETE]: true,

  [permissions.ADMIN_GROUPS]: true,
  [permissions.ADMIN_GROUPS_CREATE]: true,
  [permissions.ADMIN_GROUPS_READ]: true,
  [permissions.ADMIN_GROUPS_UPDATE]: true,
  [permissions.ADMIN_GROUPS_DELETE]: true,

  [permissions.ADMIN_COLLECTIONS]: true,
  [permissions.ADMIN_COLLECTIONS_CREATE]: true,
  [permissions.ADMIN_COLLECTIONS_READ]: true,
  [permissions.ADMIN_COLLECTIONS_UPDATE]: true,
  [permissions.ADMIN_COLLECTIONS_DELETE]: true,

  [permissions.ADMIN_ARTICLES]: true,
  [permissions.ADMIN_ARTICLES_CREATE]: true,
  [permissions.ADMIN_ARTICLES_READ]: true,
  [permissions.ADMIN_ARTICLES_UPDATE]: true,
  [permissions.ADMIN_ARTICLES_DELETE]: true,

  [permissions.ADMIN_REWARDS]: true,
  [permissions.ADMIN_REWARDS_CREATE]: true,
  [permissions.ADMIN_REWARDS_READ]: true,
  [permissions.ADMIN_REWARDS_UPDATE]: true,
  [permissions.ADMIN_REWARDS_DELETE]: true,

  [permissions.ADMIN_CHALLENGES]: true,
  [permissions.ADMIN_CHALLENGES_CREATE]: true,
  [permissions.ADMIN_CHALLENGES_READ]: true,
  [permissions.ADMIN_CHALLENGES_UPDATE]: true,
  [permissions.ADMIN_CHALLENGES_DELETE]: true,

  [permissions.ADMIN_PROGRAMS]: true,
  [permissions.ADMIN_PROGRAMS_CREATE]: true,
  [permissions.ADMIN_PROGRAMS_READ]: true,
  [permissions.ADMIN_PROGRAMS_UPDATE]: true,
  [permissions.ADMIN_PROGRAMS_DELETE]: true,

  [permissions.ADMIN_USER_PROGRAMS_READ]: true,

  [permissions.ADMIN_USERS]: true,

  [permissions.ADMIN_EXPORTS]: true,

  [permissions.ADMIN_PAYMENTS]: true,

  [permissions.ADMIN_IMAGES_UPLOAD]: true,

  [permissions.ADMIN_FEATURE_CONFIGS_PARTIAL_UPDATE]: true,

  [permissions.ADMIN_FEED_MODERATION]: true,

  [permissions.ADMIN_TRANSLATOR]: true,
};
